'use strict';

const tillerConsole = {
  _generateLogJSON(level, text, data) {
    return JSON.stringify(
      Object.assign(data, {
        level: level,
        message: text,
        correlation_id: this.correlationId,
        app_name: this.service,
        env: this.env,
      }),
    );
  },
  init(service, correlationId, env = 'preprod', oldConsole = console) {
    if (!service) {
      throw new Error('No service set');
    }

    if (!correlationId) {
      throw new Error('No correlationId set');
    }

    if (typeof service !== 'string') {
      throw new Error('Service should be a string');
    }

    if (typeof correlationId !== 'string' && typeof correlationId !== 'number') {
      throw new Error('correlationId should be a string or a number');
    }

    if (env && typeof env !== 'string') {
      throw new Error('env should be a string');
    }

    this.service = service;
    this.correlationId = correlationId;
    this.env = env;
    if (!this.oldConsole) {
      this.oldConsole = oldConsole;
    }
  },
  debug(text, data = {}) {
    this.oldConsole.log(this._generateLogJSON(7, text, data));
  },
  log(text, data = {}) {
    this.info(text, data);
  },
  info(text, data = {}) {
    this.oldConsole.log(this._generateLogJSON(6, text, data));
  },
  warn(text, data = {}) {
    this.oldConsole.warn(this._generateLogJSON(4, text, data));
  },
  error(text, data = {}) {
    this.oldConsole.error(this._generateLogJSON(3, text, data));
  },
};

module.exports = tillerConsole;
